import React from "react";
import "./ServiceCentreListingRowStyles.scss";

import { Field } from "formik";
import { Button } from "react-bootstrap";

import { ServiceCentreDetailsCard } from "components/ServiceCentreDetailsCard";
import { RadioButtonProps } from "components/generic/RadioButton";
import { ServiceCentreCardDetails } from "generated/types/types";
import { VanIcon } from "components/icons/Icons";
import { useTranslation } from "react-i18next";

//This has to align with the medium breakbpoint value that can be found in variables.scss
const mobileBreakpoint = 992;

type Props = {
    serviceCentreDetails?: ServiceCentreCardDetails;
    radioButtonProps: RadioButtonProps;
    selectedServiceCentreId: string;
    windowWidth: number;
};

export const ServiceCentreListingRow: React.FC<Props> = (props: Props) => {
    const radioButton = props.radioButtonProps;
    const { t } = useTranslation();

    return (
        <div className="listing-row">
            <div className={props.selectedServiceCentreId === radioButton.value ? "selected-service-centre" : ""}>
                <label htmlFor={radioButton.value} className="radiobutton-label" key={radioButton.value}>
                    <div className="radiobutton-inner radiobutton-inner--vertical">
                        <Field id={radioButton.value} key={radioButton.value} name="selectedServiceCentre" type="radio" value={radioButton.value} className="radiobutton" />
                        <div className="radiobutton-labels">
                            <span>{radioButton.label}</span>
                            <span className="radiobutton-secondary-label">{radioButton.preferredSupplier}</span>
                            {radioButton.secondaryLabel ? <span className="radiobutton-secondary-label">{radioButton.secondaryLabel}</span> : null}
                            {radioButton.tertiaryLabel ? <span className="radiobutton-secondary-label">{radioButton.tertiaryLabel}</span> : null}
                            {radioButton.quaternaryLabel ? <span className={`radiobutton-secondary-label ${radioButton.quaternaryClass}`}>{radioButton.quaternaryLabel}</span> : null}
                        </div>
                        {props.serviceCentreDetails?.isMobileServiceCentre ? (
                            <div className="mobile-tyre-fitter-indicator">
                                <VanIcon />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </label>
            </div>
            {/* This will only be shown on "mobile" screens */}
            {props.windowWidth <= mobileBreakpoint && props.serviceCentreDetails && props.selectedServiceCentreId === radioButton.value ? (
                <>
                    <ServiceCentreDetailsCard serviceCentreDetails={props.serviceCentreDetails} />
                    <Button type="submit" variant="primary" className="large-input">
                        {t("service_center_search_continue")}
                    </Button>
                </>
            ) : null}
        </div>
    );
};
